import { render, staticRenderFns } from "./deliveryCertNew.vue?vue&type=template&id=e1dcd840&scoped=true&"
import script from "./deliveryCertNew.vue?vue&type=script&lang=js&"
export * from "./deliveryCertNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1dcd840",
  null
  
)

export default component.exports